import React from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from 'components/error-boundary';

import { CXILayout } from './layout/CXILayout';
import { CXIModal } from './modal/CXIModal';

import { CXIRoutes } from './CXIRoutes';
import { useCXI } from './useCXI';
import { CXIContextProvider } from './CXIContext';
import { Loading } from './components/loading';

const CXIModule = () => {
    const { t } = useTranslation('cxi');
    const hookd = useCXI(true);

    return !hookd.ready ? (
        <Loading>{t('loading')}</Loading>
    ) : (
        <>
            <CXILayout className={`stage-${hookd.vars.cxi.currentStage}`}>
                <CXIRoutes t={t} useCXI={hookd} />
            </CXILayout>
            {!!hookd.modal && <CXIModal />}
        </>
    );
};

export const CXI = () => (
    <ErrorBoundary>
        <CXIContextProvider>
            <CXIModule />
        </CXIContextProvider>
    </ErrorBoundary>
);
export default CXI;
